(function () {
  const root = document.getElementById('dsh-configurator-v1');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const API_URL = 'https://test-konfigurator.adena365.de/api/dsh/commerce';
  const CART_STORAGE_KEY = 'adena365:dsh-cart:v1';
  const CHECKOUT_KEY_STORAGE_KEY = 'adena365:dsh-checkout-key:v1';
  const CART_MAX_ITEMS = 25;
  const SERIES_REVIEW_MIN_QUANTITY = 500;
  const SERIES_ALT_PRODUCTION_QUANTITY = 1000;
  const SERIES_INQUIRY_STORAGE_KEY = 'adena365:dsh-series-inquiry:v1';

  const state = {
    part: 'tube',
    material: 'PETG_STD',
    color: 'BLACK',
    quantity: 10
  };

  let geometryPolicy = null;
  let policyLoadFailed = false;
  let priceTimer = null;
  let requestSequence = 0;
  let lastResolvedCommerce = null;

  const partData = {
    washer: {
      code: 'WASHER',
      name: 'Distanzscheibe',
      heightLabel: 'Höhe H',
      dimensionCode: 'H',
      productType: 'disc'
    },
    tube: {
      code: 'TUBE',
      name: 'Distanzhülse',
      heightLabel: 'Länge L',
      dimensionCode: 'L',
      productType: 'sleeve'
    }
  };

  const materialData = {
    PETG_STD: {
      name: 'PETG Standard',
      apiCode: 'petg',
      colors: [
        { code: 'BLACK', apiCode: 'black', name: 'Schwarz' },
        { code: 'WHITE', apiCode: 'white', name: 'Weiß' },
        { code: 'GREY', apiCode: 'gray', name: 'Grau' }
      ]
    },
    PETG_TRANSPARENT: {
      name: 'PETG Transparent',
      apiCode: 'petg-transparent',
      colors: [
        { code: 'TRANSPARENT', apiCode: 'transparent', name: 'Transparent' }
      ]
    },
    PETG_CF: {
      name: 'PETG-CF',
      apiCode: 'petg-cf',
      colors: [
        { code: 'BLACK', apiCode: 'black', name: 'Schwarz' }
      ]
    }
  };

  const partButtons = root.querySelectorAll('[data-part]');
  const materialButtons = root.querySelectorAll('[data-material]');
  const quantityButtons = root.querySelectorAll('[data-quantity]');
  const colorContainer = root.querySelector('[data-color-options]');
  const customQuantityContainer = root.querySelector('[data-custom-quantity]');
  const customQuantityInput = root.querySelector('#dsh-custom-quantity');
  const adInput = root.querySelector('#dsh-ad');
  const idInput = root.querySelector('#dsh-id');
  const heightInput = root.querySelector('#dsh-height');
  const heightLabel = root.querySelector('[data-height-label]');
  const imageLabel = root.querySelector('[data-image-label]');
  const validation = root.querySelector('[data-validation]');
  const summaryPart = root.querySelector('[data-summary-part]');
  const summaryDimensions = root.querySelector('[data-summary-dimensions]');
  const summaryMaterial = root.querySelector('[data-summary-material]');
  const summaryPrice = root.querySelector('[data-summary-price]');
  const summaryPriceNote = root.querySelector('[data-summary-price-note]');
  const cartButton = root.querySelector('[data-cart-button]');
  const developmentNote = root.querySelector('.dsh-configurator__development-note');
  const shippingNote = root.querySelector('.dsh-configurator__shipping');
  const withdrawalNotice = root.querySelector('[data-withdrawal-notice]');
  const withdrawalCheckbox = root.querySelector('#dsh-withdrawal-confirm');
  const partCodeField = root.querySelector('#dsh-part-code');
  const materialCodeField = root.querySelector('#dsh-material-code');
  const colorCodeField = root.querySelector('#dsh-color-code');
  const quantityField = root.querySelector('#dsh-quantity-value');

  function parseNumber(value) {
    return Number(String(value).replace(',', '.').trim());
  }

  function parseWholeQuantity(value) {
    const raw = String(value ?? '').trim();

    if (!/^\d+$/.test(raw)) {
      return null;
    }

    const parsed = Number(raw);

    return (
      Number.isSafeInteger(parsed) &&
      parsed >= 1
    )
      ? parsed
      : null;
  }

  function quantityIsValid() {
    return (
      Number.isSafeInteger(state.quantity) &&
      state.quantity >= 1
    );
  }

  function isSeriesQuantity() {
    return (
      quantityIsValid() &&
      state.quantity >=
        SERIES_REVIEW_MIN_QUANTITY
    );
  }

  function isHighVolumeSeries() {
    return (
      quantityIsValid() &&
      state.quantity >=
        SERIES_ALT_PRODUCTION_QUANTITY
    );
  }

  function buildSeriesInquiry(validationResult) {
    const material = materialData[state.material];
    const color = selectedColor();
    const part = partData[state.part];

    if (
      !validationResult ||
      !validationResult.valid ||
      !material ||
      !color ||
      !isSeriesQuantity()
    ) {
      return null;
    }

    return {
      version: 1,
      createdAt: new Date().toISOString(),
      productType: part.productType,
      productName: part.name,
      dimensionCode: part.dimensionCode,
      dimensions: validationResult.values,
      material: {
        code: material.apiCode,
        name: material.name
      },
      color: {
        code: color.apiCode,
        name: color.name
      },
      quantity: state.quantity,
      productionReview:
        isHighVolumeSeries()
          ? 'Serienfertigung / alternatives Fertigungsverfahren prüfen'
          : 'Serienmenge / wirtschaftlichstes Fertigungsverfahren prüfen'
    };
  }

  function setSeriesMode(validationResult) {
    const inquiry =
      buildSeriesInquiry(
        validationResult
      );

    lastResolvedCommerce = null;

    summaryPrice.textContent =
      'Auf Anfrage';

    summaryPriceNote.textContent =
      isHighVolumeSeries()
        ? 'Serienfertigung wird individuell geprüft.'
        : 'Fertigungsverfahren und Serienpreis werden geprüft.';

    cartButton.disabled =
      !inquiry;

    cartButton.textContent =
      'Serienangebot anfordern';

    developmentNote.textContent =
      isHighVolumeSeries()
        ? 'Bei dieser Stückzahl vergleichen wir 3D-Druck mit geeigneten Serienverfahren und erstellen ein individuelles Angebot.'
        : 'Serienmenge erkannt: Wir prüfen das wirtschaftlichste Fertigungsverfahren und erstellen ein individuelles Angebot.';

    if (shippingNote) {
      shippingNote.textContent =
        'Versandkosten werden im Serienangebot berücksichtigt.';
    }

    if (withdrawalNotice) {
      withdrawalNotice.hidden = true;
    }
  }

  function resetNormalOrderMode() {
    updateStoredCartNote();

    if (shippingNote) {
      shippingNote.textContent =
        'Versandkostenfrei ab 9,95 € Warenkorbwert in Deutschland · darunter 1,95 € Versand & Verpackung.';
    }

    if (withdrawalNotice) {
      withdrawalNotice.hidden = false;
    }
  }

  function displayNumber(value) {
    const parsed = parseNumber(value);

    if (!Number.isFinite(parsed)) {
      return value;
    }

    return parsed.toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  function displayMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }


  function dshConfiguredTitle(
    productType,
    geometryReference,
    fallbackName
  ) {
    const base =
      productType === 'disc'
        ? 'Distanzscheibe'
        : 'Distanzhülse';

    if (
      geometryReference &&
      geometryReference.kind === 'exact'
    ) {
      return base + ' – konfigurierte Variante';
    }

    if (
      geometryReference &&
      geometryReference.kind === 'comparable'
    ) {
      return base + ' nach Maß';
    }

    return fallbackName ||
      base + ' – Konfiguration';
  }

  function selectedColor() {
    const material = materialData[state.material];

    return material.colors.find(function (item) {
      return item.code === state.color;
    }) || null;
  }

  function setValidation(message) {
    validation.textContent = message || '';
    validation.hidden = !message;
  }

  function setPricePending(text) {
    summaryPrice.textContent = '–';
    summaryPriceNote.textContent = text || 'Preis wird geprüft …';
  }

  function setCartReady(ready) {
    const legalConfirmed =
      withdrawalCheckbox
        ? withdrawalCheckbox.checked
        : false;

    cartButton.disabled =
      isSeriesQuantity()
        ? !ready
        : !(ready && legalConfirmed);

    if (!ready && !isSeriesQuantity()) {
      cartButton.textContent = 'In den Warenkorb';
    }
  }

  function loadStoredCart() {
    try {
      const raw = window.localStorage.getItem(CART_STORAGE_KEY);

      if (!raw) {
        return { items: [] };
      }

      const parsedCart = JSON.parse(raw);

      if (
        !parsedCart ||
        !Array.isArray(parsedCart.items)
      ) {
        return { items: [] };
      }

      return {
        items: parsedCart.items.slice(0, CART_MAX_ITEMS)
      };

    } catch (error) {
      return { items: [] };
    }
  }

  function saveStoredCart(cart) {
    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify(cart)
    );

    window.localStorage.removeItem(
      CHECKOUT_KEY_STORAGE_KEY
    );
  }

  function updateStoredCartNote() {
    const cart = loadStoredCart();
    const count = cart.items.length;

    if (count < 1) {
      developmentNote.textContent =
        'Preis und technische Machbarkeit werden direkt durch apa geprüft. Deine geprüfte Konfiguration wird im Browser-Warenkorb gespeichert.';
      return;
    }

    developmentNote.textContent =
      count === 1
        ? '1 geprüfte Position liegt im DSH-Warenkorb.'
        : count + ' geprüfte Positionen liegen im DSH-Warenkorb.';
  }

  function createCartItemId() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID === 'function'
    ) {
      return window.crypto.randomUUID();
    }

    return (
      'dsh-' +
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2)
    );
  }

  function buildCurrentRequest(validationResult) {
    const material = materialData[state.material];
    const color = selectedColor();

    if (
      !color ||
      !quantityIsValid()
    ) {
      return null;
    }

    return {
      kind: 'dsh-configuration',
      configuration: {
        productType: partData[state.part].productType,
        dimensions: validationResult.values,
        material: material.apiCode,
        color: color.apiCode,
        quantity: state.quantity,
        source: {
          kind: 'direct-configurator'
        }
      },
      attributes: []
    };
  }

  function validateDimensions() {
    const ad = parseNumber(adInput.value);
    const inner = parseNumber(idInput.value);
    const third = parseNumber(heightInput.value);

    if (
      !Number.isFinite(ad) ||
      !Number.isFinite(inner) ||
      !Number.isFinite(third)
    ) {
      return {
        valid: false,
        message:
          'Bitte gültige Zahlenwerte für alle Maße eingeben.'
      };
    }

    if (!geometryPolicy) {
      return {
        valid: false,
        message:
          policyLoadFailed
            ? 'Die technische Prüfung ist gerade nicht erreichbar.'
            : ''
      };
    }

    const outerLimits = geometryPolicy.outerDiameterMm;
    const innerLimits = geometryPolicy.innerDiameterMm;
    const wallLimits = geometryPolicy.wallThicknessMm;
    const thirdLimits = geometryPolicy.thirdDimensionMm;
    const typeLimits = geometryPolicy.productType;

    if (
      ad < outerLimits.min ||
      ad > outerLimits.max
    ) {
      return {
        valid: false,
        message:
          'Der Außendurchmesser muss zwischen ' +
          displayNumber(outerLimits.min) +
          ' und ' +
          displayNumber(outerLimits.max) +
          ' mm liegen.'
      };
    }

    if (inner < innerLimits.min) {
      return {
        valid: false,
        message:
          'Der Innendurchmesser muss mindestens ' +
          displayNumber(innerLimits.min) +
          ' mm betragen.'
      };
    }

    if (inner >= ad) {
      return {
        valid: false,
        message:
          'Der Außendurchmesser muss größer als der Innendurchmesser sein.'
      };
    }

    const wall = (ad - inner) / 2;

    if (wall < wallLimits.min) {
      return {
        valid: false,
        message:
          'Die Wandstärke je Seite muss mindestens ' +
          displayNumber(wallLimits.min) +
          ' mm betragen. Bei AD ' +
          displayNumber(ad) +
          ' mm darf der Innendurchmesser höchstens ' +
          displayNumber(ad - (2 * wallLimits.min)) +
          ' mm betragen.'
      };
    }

    if (
      third < thirdLimits.min ||
      third > thirdLimits.max
    ) {
      return {
        valid: false,
        message:
          partData[state.part].heightLabel +
          ' muss zwischen ' +
          displayNumber(thirdLimits.min) +
          ' und ' +
          displayNumber(thirdLimits.max) +
          ' mm liegen.'
      };
    }

    if (
      state.part === 'washer' &&
      third > typeLimits.discMaxThirdDimensionMm
    ) {
      return {
        valid: false,
        message:
          'Eine Distanzscheibe ist bis ' +
          displayNumber(typeLimits.discMaxThirdDimensionMm) +
          ' mm Höhe vorgesehen. Ab ' +
          displayNumber(typeLimits.sleeveMinThirdDimensionMm) +
          ' mm bitte Distanzhülse wählen.'
      };
    }

    if (
      state.part === 'tube' &&
      third < typeLimits.sleeveMinThirdDimensionMm
    ) {
      return {
        valid: false,
        message:
          'Eine Distanzhülse beginnt bei ' +
          displayNumber(typeLimits.sleeveMinThirdDimensionMm) +
          ' mm Länge. Bis ' +
          displayNumber(typeLimits.discMaxThirdDimensionMm) +
          ' mm bitte Distanzscheibe wählen.'
      };
    }

    return {
      valid: true,
      values: {
        outerDiameterMm: ad,
        innerDiameterMm: inner,
        thirdDimensionMm: third
      }
    };
  }

  function applyPolicyToInputs() {
    if (!geometryPolicy) {
      return;
    }

    const step = geometryPolicy.inputStepMm;

    adInput.setAttribute(
      'min',
      geometryPolicy.outerDiameterMm.min
    );

    adInput.setAttribute(
      'max',
      geometryPolicy.outerDiameterMm.max
    );

    idInput.setAttribute(
      'min',
      geometryPolicy.innerDiameterMm.min
    );

    heightInput.setAttribute(
      'min',
      geometryPolicy.thirdDimensionMm.min
    );

    heightInput.setAttribute(
      'max',
      geometryPolicy.thirdDimensionMm.max
    );

    [adInput, idInput, heightInput].forEach(function (input) {
      input.setAttribute('step', step);
    });
  }

  function updateMeasureImage() {
    root
      .querySelectorAll('[data-measure-image]')
      .forEach(function (image) {
        image.hidden =
          image.dataset.measureImage !== state.part;
      });

    imageLabel.textContent =
      partData[state.part].name;
  }

  function updatePartUi() {
    partButtons.forEach(function (button) {
      button.classList.toggle(
        'dsh-configurator__part--selected',
        button.dataset.part === state.part
      );
    });

    heightLabel.textContent =
      partData[state.part].heightLabel;

    partCodeField.value =
      partData[state.part].code;

    updateMeasureImage();
  }

  function buildColors() {
    const material = materialData[state.material];
    const allowedColors = material.colors;

    if (
      !allowedColors.some(function (color) {
        return color.code === state.color;
      })
    ) {
      state.color = allowedColors[0].code;
    }

    colorContainer.innerHTML = '';

    allowedColors.forEach(function (color) {
      const button = document.createElement('button');

      button.type = 'button';
      button.dataset.color = color.code;
      button.textContent = color.name;

      if (color.code === state.color) {
        button.classList.add('is-selected');
      }

      button.addEventListener('click', function () {
        state.color = color.code;
        buildColors();
        refresh();
      });

      colorContainer.appendChild(button);
    });

    colorCodeField.value =
      state.color;
  }

  function updateMaterialUi() {
    materialButtons.forEach(function (button) {
      button.classList.toggle(
        'is-selected',
        button.dataset.material === state.material
      );
    });

    materialCodeField.value =
      state.material;

    buildColors();
  }

  function updateSummary() {
    const part = partData[state.part];
    const material = materialData[state.material];
    const color = selectedColor();
    const quantityText =
      quantityIsValid()
        ? state.quantity
        : '–';

    summaryPart.textContent =
      part.name + ' – Konfiguration';

    summaryDimensions.textContent =
      'AD ' +
      displayNumber(adInput.value) +
      ' × ID ' +
      displayNumber(idInput.value) +
      ' × ' +
      part.dimensionCode +
      ' ' +
      displayNumber(heightInput.value) +
      ' mm';

    summaryMaterial.textContent =
      material.name +
      ' · ' +
      (color ? color.name : '') +
      ' · ' +
      quantityText +
      ' Stück';

    partCodeField.value =
      part.code;

    materialCodeField.value =
      state.material;

    colorCodeField.value =
      state.color;

    quantityField.value =
      state.quantity;
  }

  async function resolveCommerce(
    sequence,
    validationResult
  ) {
    const request =
      buildCurrentRequest(
        validationResult
      );

    if (!request) {
      return;
    }

    try {
      const response =
        await fetch(
          API_URL,
          {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
          }
        );

      const payload =
        await response.json();

      if (sequence !== requestSequence) {
        return;
      }

      if (
        response.ok &&
        payload.status === 'resolved'
      ) {
        setValidation('');

        summaryPrice.textContent =
          displayMoney(
            payload.price.grossProductPriceCents
          );

        summaryPriceNote.textContent =
          payload.price.shippingNotice &&
          payload.price.shippingNotice.text
            ? payload.price.shippingNotice.text
            : 'Preis inkl. MwSt.';

        summaryPart.textContent =
          dshConfiguredTitle(
            request.configuration.productType,
            payload.geometryReference
          );

        lastResolvedCommerce = {
          request: request,
          resolution: payload.resolution,
          geometryReference:
            payload.geometryReference,
          price: payload.price
        };

        setCartReady(true);
        return;
      }

      lastResolvedCommerce = null;
      setCartReady(false);

      const message =
        payload && payload.message
          ? payload.message
          : 'Diese Konfiguration konnte nicht geprüft werden.';

      setValidation(message);
      setPricePending('Bitte Maße prüfen.');

    } catch (error) {
      if (sequence !== requestSequence) {
        return;
      }

      lastResolvedCommerce = null;
      setCartReady(false);

      setValidation(
        'Die technische Prüfung ist gerade nicht erreichbar. Bitte versuche es erneut.'
      );

      setPricePending(
        'Preis derzeit nicht verfügbar.'
      );
    }
  }

  function scheduleCommerce() {
    window.clearTimeout(priceTimer);

    lastResolvedCommerce = null;
    setCartReady(false);

    if (!quantityIsValid()) {
      requestSequence += 1;

      setValidation(
        'Bitte eine ganze Stückzahl ab 1 eingeben.'
      );

      setPricePending(
        'Bitte Menge prüfen.'
      );

      return;
    }

    const validationResult =
      validateDimensions();

    setValidation(
      validationResult.message || ''
    );

    if (!validationResult.valid) {
      requestSequence += 1;

      setPricePending(
        geometryPolicy
          ? 'Bitte Maße prüfen.'
          : (
              policyLoadFailed
                ? 'Preis derzeit nicht verfügbar.'
                : 'Grenzwerte werden geladen …'
            )
      );

      return;
    }

    if (isSeriesQuantity()) {
      requestSequence += 1;
      setSeriesMode(
        validationResult
      );
      return;
    }

    resetNormalOrderMode();

    setPricePending(
      'Preis wird geprüft …'
    );

    const sequence =
      ++requestSequence;

    priceTimer =
      window.setTimeout(
        function () {
          resolveCommerce(
            sequence,
            validationResult
          );
        },
        250
      );
  }

  function refresh() {
    updateSummary();
    scheduleCommerce();
  }

  async function loadPolicy() {
    try {
      const response =
        await fetch(
          API_URL,
          {
            method: 'GET',
            mode: 'cors'
          }
        );

      const payload =
        await response.json();

      if (
        !response.ok ||
        payload.status !== 'configured' ||
        !payload.geometry
      ) {
        throw new Error(
          'Konfigurator-Policy konnte nicht geladen werden.'
        );
      }

      geometryPolicy =
        payload.geometry;

      policyLoadFailed = false;

      applyPolicyToInputs();
      refresh();

    } catch (error) {
      policyLoadFailed = true;
      geometryPolicy = null;
      lastResolvedCommerce = null;
      setCartReady(false);

      setValidation(
        'Die technische Prüfung ist gerade nicht erreichbar. Bitte versuche es erneut.'
      );

      setPricePending(
        'Preis derzeit nicht verfügbar.'
      );
    }
  }

  cartButton.addEventListener(
    'click',
    function () {
      if (cartButton.disabled) {
        return;
      }

      if (isSeriesQuantity()) {
        const validationResult =
          validateDimensions();

        const inquiry =
          buildSeriesInquiry(
            validationResult
          );

        if (!inquiry) {
          setValidation(
            validationResult.message ||
            'Die Serienanfrage konnte nicht vorbereitet werden.'
          );
          return;
        }

        try {
          window.localStorage.setItem(
            SERIES_INQUIRY_STORAGE_KEY,
            JSON.stringify(inquiry)
          );

          window.location.assign(
            '/pages/contact?dsh-series=1'
          );
        } catch (error) {
          setValidation(
            'Die Serienanfrage konnte im Browser nicht vorbereitet werden.'
          );
        }

        return;
      }

      if (!lastResolvedCommerce) {
        return;
      }

      if (
        withdrawalCheckbox &&
        !withdrawalCheckbox.checked
      ) {
        setValidation(
          'Bitte bestätige vor der Bestellung den Hinweis zum Widerrufsrecht bei individuell angefertigten Waren.'
        );
        withdrawalCheckbox.focus();
        return;
      }

      try {
        const cart =
          loadStoredCart();

        if (
          cart.items.length >=
          CART_MAX_ITEMS
        ) {
          setValidation(
            'Der DSH-Warenkorb kann maximal ' +
            CART_MAX_ITEMS +
            ' Positionen enthalten.'
          );

          return;
        }

        cart.items.push({
          id:
            createCartItemId(),

          displayName:
            summaryPart.textContent,

          request:
            lastResolvedCommerce.request,

          resolution:
            lastResolvedCommerce.resolution,

          geometryReference:
            lastResolvedCommerce.geometryReference,

          priceSnapshot:
            lastResolvedCommerce.price
        });

        saveStoredCart(cart);
        updateStoredCartNote();

        cartButton.textContent =
          'Hinzugefügt ✓';

        window.setTimeout(
          function () {
            if (!cartButton.disabled) {
              cartButton.textContent =
                'In den Warenkorb';
            }
          },
          1400
        );

      } catch (error) {
        setValidation(
          'Der Browser-Warenkorb konnte nicht gespeichert werden.'
        );
      }
    }
  );

  partButtons.forEach(function (button) {
    button.addEventListener(
      'click',
      function () {
        state.part =
          button.dataset.part;

        updatePartUi();
        refresh();
      }
    );
  });

  materialButtons.forEach(function (button) {
    button.addEventListener(
      'click',
      function () {
        state.material =
          button.dataset.material;

        updateMaterialUi();
        refresh();
      }
    );
  });

  quantityButtons.forEach(function (button) {
    button.addEventListener(
      'click',
      function () {
        quantityButtons.forEach(
          function (item) {
            item.classList.remove(
              'is-selected'
            );
          }
        );

        button.classList.add(
          'is-selected'
        );

        if (
          button.dataset.quantity ===
          'custom'
        ) {
          customQuantityContainer.hidden =
            false;

          state.quantity =
            parseWholeQuantity(
              customQuantityInput.value
            );

          customQuantityInput.setCustomValidity(
            quantityIsValid()
              ? ''
              : 'Bitte eine ganze Stückzahl ab 1 eingeben.'
          );

        } else {
          customQuantityContainer.hidden =
            true;

          state.quantity =
            parseInt(
              button.dataset.quantity,
              10
            );

          customQuantityInput.setCustomValidity(
            ''
          );
        }

        refresh();
      }
    );
  });

  customQuantityInput.addEventListener(
    'input',
    function () {
      state.quantity =
        parseWholeQuantity(
          customQuantityInput.value
        );

      customQuantityInput.setCustomValidity(
        quantityIsValid()
          ? ''
          : 'Bitte eine ganze Stückzahl ab 1 eingeben.'
      );

      refresh();
    }
  );

  customQuantityInput.addEventListener(
    'keydown',
    function (event) {
      if (
        ['.', ',', '-', '+', 'e', 'E']
          .includes(event.key)
      ) {
        event.preventDefault();
      }
    }
  );

  if (withdrawalCheckbox) {
    withdrawalCheckbox.addEventListener(
      'change',
      function () {
        if (!isSeriesQuantity()) {
          setValidation('');
          setCartReady(
            Boolean(lastResolvedCommerce)
          );
        }
      }
    );
  }

  [
    adInput,
    idInput,
    heightInput
  ]
  .forEach(function (input) {
    input.addEventListener(
      'input',
      refresh
    );
  });

  const prefillParams = new URLSearchParams(window.location.search);
  const prefillPart = prefillParams.get('part');

  if (prefillPart && partData[prefillPart]) {
    state.part = prefillPart;
  }

  const prefillAd = parseNumber(prefillParams.get('ad') || '');
  const prefillId = parseNumber(prefillParams.get('id') || '');
  const prefillThird = parseNumber(prefillParams.get('third') || '');

  if (Number.isFinite(prefillAd) && prefillAd > 0) {
    adInput.value = String(prefillAd).replace('.', ',');
  }

  if (Number.isFinite(prefillId) && prefillId > 0) {
    idInput.value = String(prefillId).replace('.', ',');
  }

  if (Number.isFinite(prefillThird) && prefillThird > 0) {
    heightInput.value = String(prefillThird).replace('.', ',');
  }

  updatePartUi();
  updateMaterialUi();
  updateSummary();
  updateStoredCartNote();
  setCartReady(false);
  setPricePending(
    'Grenzwerte werden geladen …'
  );
  loadPolicy();
})();


(function () {
  const root = document.getElementById('dsh-configurator-v1');
  if (!root || root.dataset.cartUiInitialized === 'true') return;
  root.dataset.cartUiInitialized = 'true';

  const CART_STORAGE_KEY = 'adena365:dsh-cart:v1';
  const CHECKOUT_KEY_STORAGE_KEY = 'adena365:dsh-checkout-key:v1';
  const CART_CHECKOUT_URL = 'https://test-konfigurator.adena365.de/api/dsh/cart/checkout';

  const cartBox = root.querySelector('[data-dsh-cart]');
  const cartCount = root.querySelector('[data-dsh-cart-count]');
  const cartSubtotal = root.querySelector('[data-dsh-cart-subtotal]');
  const cartItems = root.querySelector('[data-dsh-cart-items]');
  const cartCheckout = root.querySelector('[data-dsh-cart-checkout]');
  const cartMessage = root.querySelector('[data-dsh-cart-message]');
  const addButton = root.querySelector('[data-cart-button]');
  const note = root.querySelector('.dsh-configurator__development-note');

  if (!cartBox || !cartCount || !cartSubtotal || !cartItems || !cartCheckout || !cartMessage) {
    return;
  }

  function money(cents) {
    return (Number(cents) / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function number(value) {
    return Number(value).toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  function loadCart() {
    try {
      const raw = window.localStorage.getItem(CART_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : { items: [] };

      return {
        items: Array.isArray(parsed.items)
          ? parsed.items.slice(0, 25)
          : []
      };
    } catch (error) {
      return { items: [] };
    }
  }

  function saveCart(cart) {
    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify(cart)
    );

    window.localStorage.removeItem(
      CHECKOUT_KEY_STORAGE_KEY
    );
  }

  function setMessage(message) {
    cartMessage.textContent = message || '';
    cartMessage.hidden = !message;
  }

  function removeItem(id) {
    const cart = loadCart();

    saveCart({
      items: cart.items.filter(function (item) {
        return item.id !== id;
      })
    });

    render();
  }

  function render() {
    const cart = loadCart();
    const count = cart.items.length;

    cartBox.hidden = count < 1;
    cartItems.innerHTML = '';
    cartCheckout.disabled = count < 1;

    if (count < 1) {
      if (note) {
        note.textContent =
          'Preis und technische Machbarkeit werden direkt durch apa geprüft. Deine geprüfte Konfiguration wird im DSH-Warenkorb gespeichert.';
      }
      setMessage('');
      return;
    }

    const pieces = cart.items.reduce(function (sum, item) {
      return sum + Number(item.request?.configuration?.quantity || 0);
    }, 0);

    const subtotal = cart.items.reduce(function (sum, item) {
      return sum + Number(item.priceSnapshot?.grossProductPriceCents || 0);
    }, 0);

    cartCount.textContent =
      count === 1
        ? '1 Position · ' + pieces + ' Stück'
        : count + ' Positionen · ' + pieces + ' Stück';

    cartSubtotal.textContent = money(subtotal);

    cart.items.forEach(function (item) {
      const config = item.request.configuration;
      const dims = config.dimensions;
      const isDisc = config.productType === 'disc';

      const row = document.createElement('div');
      row.className = 'dsh-configurator__cart-item';

      const copy = document.createElement('div');
      copy.className = 'dsh-configurator__cart-item-copy';

      const title = document.createElement('strong');
      title.textContent =
        dshConfiguredTitle(
          config.productType,
          item.geometryReference,
          item.displayName
        );

      const dimension = document.createElement('span');
      dimension.textContent =
        'AD ' + number(dims.outerDiameterMm) +
        ' × ID ' + number(dims.innerDiameterMm) +
        ' × ' + (isDisc ? 'H' : 'L') +
        ' ' + number(dims.thirdDimensionMm) + ' mm';

      const quantity = document.createElement('span');
      quantity.textContent = config.quantity + ' Stück';

      copy.appendChild(title);
      copy.appendChild(dimension);
      copy.appendChild(quantity);

      const actions = document.createElement('div');
      actions.className = 'dsh-configurator__cart-item-actions';

      const price = document.createElement('strong');
      price.textContent = money(item.priceSnapshot.grossProductPriceCents);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'dsh-configurator__cart-remove';
      remove.textContent = 'Entfernen';
      remove.addEventListener('click', function () {
        removeItem(item.id);
      });

      actions.appendChild(price);
      actions.appendChild(remove);

      row.appendChild(copy);
      row.appendChild(actions);

      cartItems.appendChild(row);
    });

    if (note) {
      note.textContent =
        'DSH-Warenkorb gespeichert. Preis und Versand werden beim Checkout serverseitig erneut geprüft.';
    }
  }

  function isUuidV4(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
  }

  function createUuidV4() {
    if (window.crypto?.randomUUID) {
      return window.crypto.randomUUID();
    }

    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;

    const hex = Array.from(bytes).map(function (byte) {
      return byte.toString(16).padStart(2, '0');
    });

    return (
      hex.slice(0,4).join('') + '-' +
      hex.slice(4,6).join('') + '-' +
      hex.slice(6,8).join('') + '-' +
      hex.slice(8,10).join('') + '-' +
      hex.slice(10,16).join('')
    );
  }

  function checkoutKey() {
    const stored = window.localStorage.getItem(CHECKOUT_KEY_STORAGE_KEY);

    if (isUuidV4(stored)) {
      return stored.toLowerCase();
    }

    const key = createUuidV4();

    window.localStorage.setItem(
      CHECKOUT_KEY_STORAGE_KEY,
      key.toLowerCase()
    );

    return key.toLowerCase();
  }

  cartCheckout.addEventListener('click', async function () {
    const cart = loadCart();

    if (cart.items.length < 1) return;

    cartCheckout.disabled = true;
    cartCheckout.textContent = 'Warenkorb wird geprüft …';
    setMessage('');

    try {
      const response = await fetch(CART_CHECKOUT_URL, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          checkoutKey: checkoutKey(),
          items: cart.items.map(function (item) {
            return item.request;
          })
        })
      });

      const payload = await response.json();

      if (
        response.ok &&
        payload.status === 'checkout-ready' &&
        payload.checkout?.invoiceUrl
      ) {
        window.location.assign(payload.checkout.invoiceUrl);
        return;
      }

      if (response.ok && payload.status === 'staging-ready') {
        setMessage(
          'Test erfolgreich: ' +
          money(payload.summary.totalCents) +
          ' Gesamtbetrag. Im Staging wurde noch kein Shopify-Checkout erzeugt.'
        );
        return;
      }

      setMessage(
        payload?.message ||
        'Der Warenkorb konnte nicht geprüft werden.'
      );

    } catch (error) {
      setMessage(
        'Der Warenkorb konnte technisch nicht geprüft werden.'
      );
    } finally {
      cartCheckout.disabled = false;
      cartCheckout.textContent = 'Warenkorb prüfen';
    }
  });

  if (addButton) {
    addButton.addEventListener('click', function () {
      window.setTimeout(render, 0);
    });
  }

  window.addEventListener('storage', function (event) {
    if (event.key === CART_STORAGE_KEY) {
      render();
    }
  });

  render();
})();